import { localStage, STAGE_NAME } from '@shared/constants';
import { ReportSettingsType } from '@shared/types/ReportTypes';

/**
 * Reads out the feature flag.
 * https://prismacode.visualstudio.com/prismacloud/_wiki/wikis/prismacloud.wiki/366/Feature-Flag-(WebApp)
 *
 * Example how to create a feature flag.
 * export const IsP3ConfigureDeviceEnabled: () => boolean = fromEnvironmentVariableOrOnStage(
 *   '$WEBAPP_P3ConfigureDeviceEnabled',
 *   localStage
 * );
 */
function fromEnvironmentVariableOrOnStage(envVariableValue: string, ...stages: string[]): boolean {
  if (envVariableValue === '1' || envVariableValue.toLowerCase() === 'true') {
    return true;
  }

  return stages.indexOf(STAGE_NAME) > -1;
}

export const getDefaultLanguage: () => string = () => {
  if (STAGE_NAME === localStage) {
    return 'en';
  }

  return 'ja';
};

export const getEnabledLanguagesRegEx: () => string = () => {
  if (STAGE_NAME === localStage) {
    return '';
  }

  return '(en|ja)';
};

export const isBrandingEnabledForStage = (): boolean => {
  return fromEnvironmentVariableOrOnStage('false', localStage);
};

export const isPatientAppSettingShownForStage = (): boolean => {
  return fromEnvironmentVariableOrOnStage('false', localStage);
};

/**
 * Returns ComplianceSummary or DeviceCompliance type.
 */
export const getComplianceTypeForStage = (): ReportSettingsType => {
  if (STAGE_NAME === localStage) {
    return 'ComplianceSummary';
  }

  return 'ComplianceSummary' as ReportSettingsType;
};

export const getStatusPageIdForStage = (): string => {
  if (STAGE_NAME === localStage) {
    return '5fmf3jg407nz';
  }

  return '8h705dl1nl7s';
};

export const isPrismaFirmwareDownloadAllowedForStage = (): boolean => {
  return fromEnvironmentVariableOrOnStage('true', localStage);
};

export const isTeleSettingAllowedForStage = (): boolean => {
  if (STAGE_NAME === localStage) {
    return true;
  }
  return !fromEnvironmentVariableOrOnStage('true');
};

export const areQuestionnairesEnabledForStage = () =>
  fromEnvironmentVariableOrOnStage('false', localStage);

export const isTrendCurvesViewerEnabledForStage = () =>
  fromEnvironmentVariableOrOnStage('false', localStage);

export const isAnnualOverviewEnabledForStage = () =>
  fromEnvironmentVariableOrOnStage('false', localStage);

export const isTelemonitoringSwitchingAllowedForStage = (): boolean => {
  if (STAGE_NAME === localStage) {
    return true;
  }
  return !fromEnvironmentVariableOrOnStage('true');
};

export const getKibanaUrlForStage: () => string = () => {
  if (STAGE_NAME === localStage) {
    return '';
  }
  return 'https://logs.prismacloud.cc/app/data-explorer/discover#';
};

export const getKibanaIndexUnidForStage: () => string = () => {
  if (STAGE_NAME === localStage) {
    return '';
  }
  return '8cc29640-e55c-11f0-91a4-4d339670f763';
};

export const getShowListOfControls = () => {
  if (STAGE_NAME == localStage || STAGE_NAME.includes('today')) {
    return true;
  }
};

window.GetComplianceType = getComplianceTypeForStage;
